import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleArrowUp } from '@fortawesome/free-solid-svg-icons';
import './BackToTop.scss';

const BackToTop = () => {
	const [visibilityClass, setVisibilityClass] = useState('');

	const updateVisibility = () => {
		const scrolled = window.scrollY > 67;
		const distanceFromBottom = document.body.offsetHeight - (window.innerHeight + window.scrollY);
		const scrolledToBottom = window.scrollY > 0 && distanceFromBottom <= 20;

		if (scrolledToBottom) {
			setVisibilityClass('is-at-bottom');
		} else if (scrolled) {
			setVisibilityClass('is-visible');
		} else {
			setVisibilityClass('');
		}
	};


	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
		if (window.location.hash) {
			window.history.replaceState(null, '', window.location.pathname + window.location.search);
		}
	};

	useEffect(() => {
		window.addEventListener('scroll', updateVisibility);
		return () => {
			window.removeEventListener('scroll', updateVisibility);
		};
	}, []);

	return (
		<div className={`backToTop ${visibilityClass}`}>
			<div onClick={scrollToTop} className={`backToTopIcon`}>
				<FontAwesomeIcon icon={faCircleArrowUp} />
			</div>
		</div>
	);
};

export default BackToTop;
